import { TopolSocialBlock } from "@/schemas/template/blocks/socialBlockSchema";
import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";
import { useMjmlStore } from "@/stores/mjmlStore";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number }
  ): TopolSocialBlock {
    const mjmlStore = useMjmlStore();
    return {
      uid: uuidv4(),
      tagName: "mj-social",
      attributes: {
        padding:
          mjmlStore.getBaseAttrString("mj-social", "padding") ||
          "10px 10px 10px 10px",
        "text-mode": "false",
        "icon-size":
          mjmlStore.getBaseAttrString("mj-social", "icon-size") || "35px",
        align: mjmlStore.getBaseAttrString("mj-social", "align") || "center",
        "icon-padding":
          mjmlStore.getBaseAttrString("mj-social", "icon-padding") || undefined,
        containerWidth: calcWidth(
          state.mjml.children[0].attributes["containerWidth"],
          state.mjml.children[0].children[props.sectionIndex].children[
            props.columnIndex
          ].attributes["width"]
        ),
      },
      children: [
        {
          tagName: "mj-social-element",
          attributes: {
            src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/facebook.png",
            name: "facebook-noshare",
            alt: "Facebook",
            href: "https://www.facebook.com/PROFILE",
            "background-color": "transparent",
            show: true,
          },
        },
        {
          tagName: "mj-social-element",
          attributes: {
            src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/x.png",
            name: "x-noshare",
            alt: "X",
            href: "https://www.x.com/PROFILE",
            "background-color": "transparent",
            show: true,
          },
        },
        {
          tagName: "mj-social-element",
          attributes: {
            src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/linkedin.png",
            name: "linkedin-noshare",
            alt: "LinkedIn",
            href: "https://www.linkedin.com/PROFILE",
            "background-color": "transparent",
            show: true,
          },
        },
        {
          tagName: "mj-social-element",
          attributes: {
            src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/instagram.png",
            alt: "Instagram",
            name: "instagram",
            href: "https://www.instagram.com/PROFILE",
            "background-color": "transparent",
            show: true,
          },
        },
      ],
    };
  },
};
